import React, { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import useAuth from "@/hooks/useAuth";
import {
  isReportingAccessVerified,
  clearReportingAccessSession,
} from "./reporting-otp-storage";
import ReportingOtpModal from "./reporting-otp-modal";

export default function ReportingAccessGuard() {
  const { user } = useAuth();
  const location = useLocation();

  const [isVerified, setIsVerified] = useState(() => isReportingAccessVerified());

  const rawDesignation = String(user?.designation || "").trim();
  const lowerDesignation = rawDesignation.toLowerCase();
  const isOwnerOrManager =
    lowerDesignation === "owner" || lowerDesignation === "manager";

  // Watch location: If navigating away from reporting module, immediately destroy session
  useEffect(() => {
    if (!location.pathname.startsWith("/reporting")) {
      clearReportingAccessSession();
      setIsVerified(false);
    }
  }, [location.pathname]);

  // When unmounting (navigating outside the reporting routes), destroy verification session
  useEffect(() => {
    return () => {
      clearReportingAccessSession();
    };
  }, []);

  // If user is not Owner or Manager, no OTP verification is required
  if (!isOwnerOrManager) {
    return <Outlet />;
  }

  // If Owner or Manager is already verified in this reporting session
  if (isVerified) {
    return <Outlet />;
  }

  // Owner or Manager NOT yet verified: show blurred background and non-dismissable OTP modal
  return (
    <div className="relative h-screen w-full overflow-hidden">
      {/* Blurred background view of reporting */}
      <div
        aria-hidden="true"
        className="filter blur-[5px] opacity-85 pointer-events-none select-none transition-all duration-300 w-full h-full"
      >
        <Outlet />
      </div>

      {/* Security Verification Modal */}
      <ReportingOtpModal
        isOpen={true}
        designation={rawDesignation || "Manager"}
        onSuccess={() => setIsVerified(true)}
      />
    </div>
  );
}
